/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaxDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaxDiscount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/MaxDiscount",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let rulesetMaxDiscountValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount',
})
let rulesetMaxDiscountChangeData = fromData.useDataChange({ viewPath,
context: 'ruleset',
path: 'max_discount',
})
  return (<React.Fragment
>
<div
  data-testid="MaxDiscount.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-ZndV0O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-ZndV0O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-ZndV0O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZndV0O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="MaxDiscount.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-5-ZndV0O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-6-ZndV0O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<InputSmallLabel
  viewPath={`${viewPath}/InputSmallLabel`}
 label="max discount"
 type="number"
 data="ruleset.max_discount"
 onChange={rulesetMaxDiscountChangeData}
 value={rulesetMaxDiscountValueData}
 width={130}
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginBottom={dtSpaceXs}
 text="%"
/>
</div>
</div>
{children}
</React.Fragment>)
}